/**
 * Constants for BlogDetailsPage component labels and text
 */

export const BLOG_AUTHOR_LABELS = {
	WRITTEN_BY: 'Written by',
	MEDICALLY_REVIEWED_BY: 'Medically reviewed by',
	AUTHORED_BY: 'Authored by',
} as const;
